import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { BaseCell, BaseHeader } from './Column';
import { FormattedTime, Responsive } from '../../../../../../ui';
import { Color } from '../../../../../../styles/Color';

interface IProps {
	scheduledTimeStamp: number;
	actualTimestamp: number;
}

const styles = css`
	min-width: 100px;
	max-width: 100px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		min-width: 85px;
		max-width: 85px;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	color: ${Color.Neutral};
	display: flex;
	flex-direction: column;
`;

export const StyledFormattedTime = styled(FormattedTime)`
	margin: 0;
`;

export function Header() {
	return <StyledHeader css={styles}>Time</StyledHeader>;
}

export function Cell({ scheduledTimeStamp, actualTimestamp }: IProps) {
	return (
		<StyledCell>
			<FormattedTime
				value={scheduledTimeStamp}
				isStrikeThrough={scheduledTimeStamp !== actualTimestamp}
			/>
			{scheduledTimeStamp !== actualTimestamp && (
				<StyledFormattedTime
					value={actualTimestamp}
					isNewTime={scheduledTimeStamp !== actualTimestamp}
				/>
			)}
		</StyledCell>
	);
}
